import { OnlineBriefingTemplateConfigModel } from '../models/online-briefing-option.model';
import { OnlineBriefingTemplateEnum } from '../enums/online-briefing-template.enum';
import { QuarterlyDateRangeSettingsModel } from '../../Shared/models/quarterly-date-range-settings.model';
import { MonthlyDateRangeSettingsModel } from '@Monitor/Shared/models/monthly-date-range-settings.model';

export const onlineBriefingOptionDefault: OnlineBriefingTemplateConfigModel = {
    version: '1.0',
    template: OnlineBriefingTemplateEnum.ONLINE_BRIEFING_TEMPLATE_DEFAULT,
    deliverySchedulingType: null,
    allowAi: false,
    accentColor: null,
    bannerStyle: null,
    analysisFocus: null,
    dataSource: null,
    competitors: [],
    name: null,
    logo: [],
    brand: null,
    monthlySettings: new MonthlyDateRangeSettingsModel(),
    quarterlySettings: new QuarterlyDateRangeSettingsModel()
} as unknown as OnlineBriefingTemplateConfigModel;
